package com.shadowings.gero.presentation.screen

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.scaleIn
import androidx.compose.animation.scaleOut
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ElevatedCard
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.material3.ListItem
import androidx.compose.material3.ListItemDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedCard
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.input.nestedscroll.nestedScroll
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.platform.LocalInspectionMode
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.intl.Locale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.toUpperCase
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.navigation.NavGraph.Companion.findStartDestination
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.composable
import androidx.navigation.compose.currentBackStackEntryAsState
import androidx.navigation.compose.rememberNavController
import com.shadowings.gero.data.datasource.chapterOne
import com.shadowings.gero.data.datasource.defaultChapters
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.data.repository.UniliteralRepository
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.LessonIds
import com.shadowings.gero.domain.model.LessonNode
import com.shadowings.gero.domain.model.LessonType
import com.shadowings.gero.domain.model.UserData
import com.shadowings.gero.getPlatform
import com.shadowings.gero.presentation.component.BottomBar
import com.shadowings.gero.presentation.component.LeftNavigationBar
import com.shadowings.gero.presentation.component.RightStatsColumn
import com.shadowings.gero.presentation.component.StatType
import com.shadowings.gero.presentation.component.TopBar
import com.shadowings.gero.presentation.component.WebNavigationDrawer
import com.shadowings.gero.presentation.component.avatars.AlynAvatar
import com.shadowings.gero.presentation.component.avatars.InteractiveAvatar
import com.shadowings.gero.presentation.model.LandingUiState
import com.shadowings.gero.presentation.model.UiLessonNode
import com.shadowings.gero.presentation.model.UiLessonRow
import com.shadowings.gero.presentation.model.Word
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.ui.disabledNeutralBg
import com.shadowings.gero.presentation.ui.disabledNeutralText
import com.shadowings.gero.presentation.ui.hieroglyphTint
import com.shadowings.gero.presentation.ui.lessonHintText
import com.shadowings.gero.presentation.ui.lessonLockedButtonBorder
import com.shadowings.gero.presentation.ui.lessonLockedContainer
import com.shadowings.gero.presentation.ui.lessonLockedTint
import com.shadowings.gero.presentation.ui.lessonPerfectContainer
import com.shadowings.gero.presentation.util.ColumnOrRow
import com.shadowings.gero.presentation.util.DeviceClass
import com.shadowings.gero.presentation.util.DeviceInfo
import com.shadowings.gero.presentation.util.DevicePreviews
import com.shadowings.gero.presentation.util.rememberDeviceInfo
import com.shadowings.gero.presentation.util.rememberFeedbackDebugInfo
import com.shadowings.gero.presentation.viewmodel.LandingViewModel
import com.shadowings.gero.util.FeedbackEmail
import com.shadowings.gero.util.FeedbackType
import com.shadowings.gero.util.rememberFeedbackSender
import com.shadowings.gero.util.systemLanguageCode
import compose.icons.FeatherIcons
import compose.icons.feathericons.ChevronRight
import compose.icons.feathericons.Mail
import gero.composeapp.generated.resources.A2
import gero.composeapp.generated.resources.A33
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.all_lessons_completed
import gero.composeapp.generated.resources.attrezzi_scriba
import gero.composeapp.generated.resources.bocca
import gero.composeapp.generated.resources.chapter_title_format
import gero.composeapp.generated.resources.chiudi_btn
import gero.composeapp.generated.resources.daily_review_btn
import gero.composeapp.generated.resources.impara_btn
import gero.composeapp.generated.resources.inizia_btn
import gero.composeapp.generated.resources.investiga_btn
import gero.composeapp.generated.resources.lesson_stars_earned_desc
import gero.composeapp.generated.resources.libro
import gero.composeapp.generated.resources.occhio
import gero.composeapp.generated.resources.quiz_btn
import gero.composeapp.generated.resources.request_more_lessons_btn
import gero.composeapp.generated.resources.request_more_lessons_email_body
import gero.composeapp.generated.resources.request_more_lessons_email_subject
import gero.composeapp.generated.resources.scroll_to_current_lesson_desc
import gero.composeapp.generated.resources.stella
import gero.composeapp.generated.resources.stella_full
import gero.composeapp.generated.resources.stella_perfetta
import gero.composeapp.generated.resources.triangle90
import gero.composeapp.generated.resources.unlock_quiz_explanation_hint
import gero.composeapp.generated.resources.unlock_requirements_hint
import gero.composeapp.generated.resources.walkthrough_text
import gero.composeapp.generated.resources.walkthrough_text_builder
import gero.composeapp.generated.resources.walkthrough_text_compendio
import gero.composeapp.generated.resources.walkthrough_text_personaggi
import gero.composeapp.generated.resources.walkthrough_text_profile
import gero.composeapp.generated.resources.walkthrough_unlock_builder
import gero.composeapp.generated.resources.walkthrough_unlock_compendio
import gero.composeapp.generated.resources.walkthrough_unlock_personaggi
import gero.composeapp.generated.resources.walkthrough_unlock_title
import gero.composeapp.generated.resources.walkthrough_welcome_builder
import gero.composeapp.generated.resources.walkthrough_welcome_compendio
import gero.composeapp.generated.resources.walkthrough_welcome_personaggi
import gero.composeapp.generated.resources.walkthrough_welcome_profile
import gero.composeapp.generated.resources.walkthrough_welcome_title
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel


@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
fun LandingScreenPreview() {
    val previewUserData = UserData(
        explanations = setOf(LessonIds.INTRO_HIEROGLYPHS, LessonIds.INTRO_HIEROGLYPHS_2),
        stars = mapOf(
            LessonIds.INTRO_HIEROGLYPHS to 3
        ),
        tutorialDone = true
    )
    AppTheme {
        Surface {
            LandingScreenContent(
                uiState = LandingUiState(
                    chapters = defaultChapters,
                    userData = previewUserData,
                    lessonRowsPerChapter = defaultChapters.associate { chapter ->
                        chapter.number to listOf(
                            UiLessonRow(
                                lessons = chapterOne.map { lesson ->
                                    UiLessonNode(
                                        lesson = lesson,
                                        isLocked = !previewUserData.explanations.contains(lesson.id),
                                        earnedStars = previewUserData.stars[lesson.id] ?: 0,
                                        isPerfect = (previewUserData.stars[lesson.id] ?: 0) == 3
                                    )
                                }
                            )
                        )
                    }
                ),
                onExplanationClick = {},
                onQuizClick = {},
                onAuthClick = {},
                starsNeeded = emptyMap()
            )
        }
    }
}

@Composable
fun LandingScreen(
    onExplanationClick: (lessonId: String) -> Unit,
    onQuizClick: (lessonId: String) -> Unit,
    onRuleClick: (ruleId: String) -> Unit = {},
    onAuthClick: () -> Unit,
    onFeaturePollClick: () -> Unit = {},
    purchaseFullVersion: () -> Unit = {},
    isFullVersionUnlocked: Boolean = false,
    restoreFullVersionPurchases: () -> Unit = {},
    modifier: Modifier = Modifier,
    viewModel: LandingViewModel = koinViewModel(),
) {
    val uiState by viewModel.uiState.collectAsStateWithLifecycle()
    val starsNeeded by viewModel.starsNeeded.collectAsStateWithLifecycle()

    var builderTextState by rememberSaveable(stateSaver = TextFieldValue.Saver) {
        mutableStateOf(TextFieldValue("M17-Y5:N35-G43B-S34"))
    }
    var builderIsRtl by rememberSaveable { mutableStateOf(false) }
    var builderIsCartouche by rememberSaveable { mutableStateOf(true) }
    var builderSymbolSize by rememberSaveable { mutableStateOf(64f) }

    LandingScreenContent(
        uiState = uiState,
        onExplanationClick = onExplanationClick,
        onQuizClick = onQuizClick,
        onRuleClick = onRuleClick,
        onAuthClick = onAuthClick,
        onFeaturePollClick = onFeaturePollClick,
        purchaseFullVersion = purchaseFullVersion,
        isFullVersionUnlocked = isFullVersionUnlocked,
        restoreFullVersionPurchases = restoreFullVersionPurchases,
        modifier = modifier,
        starsNeeded = starsNeeded,
        onToggleFavoriteHiero = { viewModel.toggleFavoriteHiero(it) },
        onToggleFavoriteWord = { viewModel.toggleFavoriteWord(it) },
        onStatClick = { stat ->
            viewModel.logStatClicked(stat.name)
            if (stat == StatType.STRIKE) viewModel.acknowledgeStreakRestorationBadge()
        },
        onWordViewed = { word ->
            val languageCode = uiState.userData.language.ifBlank { systemLanguageCode() }
            viewModel.logWordViewed(word.id, word.getMeaning(languageCode))
        },
        onHieroViewed = { hiero -> viewModel.logHieroViewed(hiero.gardinerCode, hiero.unicode) },
        onBottomBarClick = { viewModel.onBottomBarClick(it) },
        onLearnTabSelected = { viewModel.onLearnTabClick(it) },
        onCompendioTabSelected = { viewModel.onCompendioTabClick(it) },
        onCompleteWalkthrough = { viewModel.completeWalkthrough() },
        onCompleteTabWalkthrough = { viewModel.completeTabWalkthrough(it) },
        builderTextState = builderTextState,
        onBuilderTextStateChange = { builderTextState = it },
        builderIsRtl = builderIsRtl,
        onBuilderIsRtlChange = { builderIsRtl = it },
        builderIsCartouche = builderIsCartouche,
        onBuilderIsCartoucheChange = { builderIsCartouche = it },
        builderSymbolSize = builderSymbolSize,
        onBuilderSymbolSizeChange = { builderSymbolSize = it },
        onSaveBuilderWord = { viewModel.saveBuilderWord(it) },
        onDeleteBuilderWord = { viewModel.deleteBuilderWord(it) },
        onUpdateBuilderWord = { viewModel.updateBuilderWord(it) },
        onRedeemStreakRestoration = { dateStr -> viewModel.redeemStreakRestoration(dateStr) }
    )
}

private enum class LockedFeature { COMPENDIO, BUILDER, PERSONAGGI }

@OptIn(ExperimentalMaterial3Api::class, ExperimentalComposeUiApi::class)
@Composable
fun LandingScreenContent(
    uiState: LandingUiState,
    onExplanationClick: (lessonId: String) -> Unit,
    onQuizClick: (lessonId: String) -> Unit,
    onRuleClick: (ruleId: String) -> Unit = {},
    onAuthClick: () -> Unit,
    onFeaturePollClick: () -> Unit = {},
    purchaseFullVersion: () -> Unit = {},
    isFullVersionUnlocked: Boolean = false,
    restoreFullVersionPurchases: () -> Unit = {},
    modifier: Modifier = Modifier,
    onToggleFavoriteHiero: (String) -> Unit = {},
    onToggleFavoriteWord: (String) -> Unit = {},
    onStatClick: (StatType) -> Unit = {},
    onWordViewed: (Word) -> Unit = {},
    onHieroViewed: (Hiero) -> Unit = {},
    onBottomBarClick: (Int) -> Unit = {},
    onLearnTabSelected: (Int) -> Unit = {},
    onCompendioTabSelected: (Int) -> Unit = {},
    onCompleteWalkthrough: () -> Unit = {},
    onCompleteTabWalkthrough: (Int) -> Unit = {},
    builderTextState: TextFieldValue = TextFieldValue("M17-Y5:N35-G43B-S34"),
    onBuilderTextStateChange: (TextFieldValue) -> Unit = {},
    builderIsRtl: Boolean = false,
    onBuilderIsRtlChange: (Boolean) -> Unit = {},
    builderIsCartouche: Boolean = true,
    onBuilderIsCartoucheChange: (Boolean) -> Unit = {},
    builderSymbolSize: Float = 64f,
    onBuilderSymbolSizeChange: (Float) -> Unit = {},
    onSaveBuilderWord: (com.shadowings.gero.domain.model.SavedBuilderWord) -> Unit = {},
    onDeleteBuilderWord: (String) -> Unit = {},
    onUpdateBuilderWord: (com.shadowings.gero.domain.model.SavedBuilderWord) -> Unit = {},
    onRedeemStreakRestoration: (String) -> Unit = {},
    starsNeeded: Map<String, Int>
) {
    val deviceInfo = rememberDeviceInfo()

    val landingNavController = rememberNavController()
    val navBackStackEntry by landingNavController.currentBackStackEntryAsState()
    val currentRoute = navBackStackEntry?.destination?.route

    // Ordine bottom bar/rail/drawer web (BottomBar, LeftNavigationBar, WebNavigationDrawer):
    // 0 Impara (Capitoli/Correggi come tab interne - vedi LearnScreen), 1 Compendio, 2 Builder,
    // 3 Personaggi, 4 Profilo.
    val selectedIndex = when (currentRoute) {
        "chapters" -> 0
        "compendio" -> 1
        "builder" -> 2
        "characters" -> 3
        "profile" -> 4
        else -> 0
    }
    val userData = uiState.userData
    val totalStars = userData.stars.values.sum()
    val hasAvailableStreakRestoration = userData.streakRestorationTokens.values.any { !it } &&
            !userData.streakRestorationBadgeSeen
    var lockedFeatureToShow by remember { mutableStateOf<LockedFeature?>(null) }

    // Onboarding Walkthrough state
    val showOnboarding = !userData.walkthroughDone && userData.tutorialDone == true

    val activeStatExplanation = remember { mutableStateOf<StatType?>(null) }

    // La TopBar scorre via quando si scrolla il contenuto della sezione e ricompare scrollando
    // verso l'alto. Cambiando sezione la si fa ricomparire, altrimenti resterebbe nascosta su
    // una schermata magari non scrollabile.
    val topBarScrollBehavior = TopAppBarDefaults.enterAlwaysScrollBehavior()
    LaunchedEffect(currentRoute) {
        topBarScrollBehavior.state.heightOffset = 0f
    }

    // Intercept clicks on locked navigation tabs
    val navigateToTab: (Int) -> Unit = { index ->
        onBottomBarClick(index)
        val requiredStars = when (index) {
            1 -> 1
            2 -> 30
            3 -> 10
            else -> 0
        }
        if (totalStars < requiredStars) {
            lockedFeatureToShow = when (index) {
                1 -> LockedFeature.COMPENDIO
                2 -> LockedFeature.BUILDER
                3 -> LockedFeature.PERSONAGGI
                else -> null
            }
        } else {
            val route = when (index) {
                0 -> "chapters"
                1 -> "compendio"
                2 -> "builder"
                3 -> "characters"
                4 -> "profile"
                else -> "chapters"
            }
            landingNavController.navigate(route) {
                popUpTo(landingNavController.graph.findStartDestination().id) {
                    saveState = true
                }
                launchSingleTop = true
                restoreState = true
            }
        }
    }

    // LandingScreen — Box radice
    Box(
        modifier = modifier
            .fillMaxSize()
            .semantics { testTag = "landing_screen" }
    ) {
        BoxWithConstraints(modifier = Modifier.fillMaxSize()) {
            val isLandscape = maxWidth > maxHeight
            // Wide web viewports get a single always-open left drawer, instead of the landscape phone/tablet's split
            // LeftNavigationBar + RightStatsColumn. Gated on width so a narrow/mobile-emulated
            // browser window still falls through to the normal isLandscape/portrait layouts.
            val isWideWebLayout = deviceInfo.deviceClass == DeviceClass.WEB_FULL

            Row(modifier = Modifier.fillMaxSize()) {
                if (isWideWebLayout) {
                    WebNavigationDrawer(
                        selectedIndex = selectedIndex,
                        isLoggedIn = uiState.isLoggedIn,
                        language = userData.language,
                        starCount = totalStars,
                        onItemSelected = navigateToTab
                    )
                } else if (isLandscape) {
                    LeftNavigationBar(
                        selectedIndex = selectedIndex,
                        isLoggedIn = uiState.isLoggedIn,
                        language = userData.language,
                        starCount = totalStars,
                        onItemSelected = navigateToTab
                    )
                }

                Scaffold(
                    modifier = Modifier
                        .weight(1f)
                        .then(
                            // Su web full la TopBar resta fissa: niente scroll behavior.
                            if (isWideWebLayout) {
                                Modifier
                            } else {
                                Modifier.nestedScroll(topBarScrollBehavior.nestedScrollConnection)
                            }
                        ),
                    topBar = {
                        if (!isLandscape && !isWideWebLayout) {
                            TopBar(
                                strikeCount = userData.strike,
                                level = com.shadowings.gero.domain.model.GameConstants.getPlayerLevel(
                                    userData.experience
                                ),
                                starCount = totalStars,
                                heartsCount = if (isFullVersionUnlocked) 999 else userData.hearts,
                                showHearts = !isFullVersionUnlocked,
                                hasAvailableStreakRestoration = hasAvailableStreakRestoration,
                                onStatClick = { stat ->
                                    activeStatExplanation.value = stat
                                    onStatClick(stat)
                                },
                                scrollBehavior = topBarScrollBehavior
                            )
                        } else if (isWideWebLayout) {
                            TopBar(
                                strikeCount = userData.strike,
                                level = com.shadowings.gero.domain.model.GameConstants.getPlayerLevel(
                                    userData.experience
                                ),
                                starCount = totalStars,
                                heartsCount = if (isFullVersionUnlocked) 999 else userData.hearts,
                                showHearts = !isFullVersionUnlocked,
                                hasAvailableStreakRestoration = hasAvailableStreakRestoration,
                                onStatClick = { stat ->
                                    activeStatExplanation.value = stat
                                    onStatClick(stat)
                                },
                                scrollBehavior = null
                            )
                        }
                    },
                    bottomBar = {
                        if (!isLandscape && !isWideWebLayout) {
                            BottomBar(
                                selectedIndex = selectedIndex,
                                isLoggedIn = uiState.isLoggedIn,
                                language = userData.language,
                                starCount = totalStars,
                                onItemSelected = navigateToTab
                            )
                        }
                    }
                ) { paddingValues ->
                    NavHost(
                        navController = landingNavController,
                        startDestination = "chapters",
                        modifier = Modifier
                            .fillMaxSize()
                            .padding(paddingValues)
                            .then(
                                if (isWideWebLayout) {
                                    Modifier.padding(start = 48.dp)
                                } else {
                                    Modifier
                                }
                            )
                    ) {
                        composable("chapters") {
                            LearnScreen(
                                uiState = uiState,
                                onExplanationClick = onExplanationClick,
                                onQuizClick = onQuizClick,
                                starsNeeded = starsNeeded,
                                onTabSelected = {
                                    topBarScrollBehavior.state.heightOffset = 0f
                                    onLearnTabSelected(it)
                                },
                                modifier = Modifier.fillMaxSize()
                            )
                        }
                        composable("compendio") {
                            CompendioScreen(
                                uiState = uiState,
                                onToggleFavoriteHiero = onToggleFavoriteHiero,
                                onToggleFavoriteWord = onToggleFavoriteWord,
                                onWordViewed = onWordViewed,
                                onHieroViewed = onHieroViewed,
                                onRuleClick = onRuleClick,
                                onTabSelected = {
                                    topBarScrollBehavior.state.heightOffset = 0f
                                    onCompendioTabSelected(it)
                                },
                                modifier = Modifier.fillMaxSize()
                            )
                        }
                        composable("characters") {
                            CharacterScreen(
                                modifier = Modifier.fillMaxSize(),
                                onPurchaseFullVersion = purchaseFullVersion
                            )
                        }
                        composable("builder") {
                            BuilderScreen(
                                uiState = uiState,
                                textState = builderTextState,
                                onTextStateChange = onBuilderTextStateChange,
                                isRtl = builderIsRtl,
                                onIsRtlChange = onBuilderIsRtlChange,
                                isCartouche = builderIsCartouche,
                                onIsCartoucheChange = onBuilderIsCartoucheChange,
                                symbolSize = builderSymbolSize,
                                onSymbolSizeChange = onBuilderSymbolSizeChange,
                                isFullVersionUnlocked = isFullVersionUnlocked,
                                onSaveBuilderWord = onSaveBuilderWord,
                                onDeleteBuilderWord = onDeleteBuilderWord,
                                onUpdateBuilderWord = onUpdateBuilderWord,
                                onPurchaseFullVersion = purchaseFullVersion,
                                modifier = Modifier.fillMaxSize()
                            )
                        }
                        composable("profile") {
                            ProfileScreen(
                                onAuthClick = onAuthClick,
                                onFeaturePollClick = onFeaturePollClick,
                                onPurchaseFullVersion = purchaseFullVersion,
                                onRestorePurchases = restoreFullVersionPurchases,
                                isFullVersionUnlocked = isFullVersionUnlocked,
                                modifier = Modifier.fillMaxSize()
                            )
                        }
                    }
                }
                if (isLandscape && !isWideWebLayout) {
                    RightStatsColumn(
                        strikeCount = userData.strike,
                        level = com.shadowings.gero.domain.model.GameConstants.getPlayerLevel(
                            userData.experience
                        ),
                        starCount = totalStars,
                        heartsCount = if (isFullVersionUnlocked) 999 else userData.hearts,
                        showHearts = !isFullVersionUnlocked,
                        hasAvailableStreakRestoration = hasAvailableStreakRestoration,
                        onStatClick = { stat ->
                            activeStatExplanation.value = stat
                            onStatClick(stat)
                        }
                    )
                }
            }
        }

        activeStatExplanation.value?.let { statType ->
            StatExplanationBottomSheet(
                statType = statType,
                userData = userData,
                onDismiss = { activeStatExplanation.value = null },
                isFullVersionUnlocked = isFullVersionUnlocked,
                onPurchaseFullVersion = purchaseFullVersion,
                onRedeemStreakRestoration = onRedeemStreakRestoration
            )
        }

        lockedFeatureToShow?.let { feature ->
            val title = stringResource(Res.string.walkthrough_unlock_title)
            val text = when (feature) {
                LockedFeature.COMPENDIO -> stringResource(Res.string.walkthrough_unlock_compendio)
                LockedFeature.BUILDER -> stringResource(Res.string.walkthrough_unlock_builder)
                LockedFeature.PERSONAGGI -> stringResource(Res.string.walkthrough_unlock_personaggi)
            }
            AlertDialog(
                onDismissRequest = { lockedFeatureToShow = null },
                confirmButton = {
                    TextButton(
                        onClick = { lockedFeatureToShow = null },
                        modifier = Modifier.semantics {
                            testTag = "landing_btn_locked_feature_close"
                        }
                    ) {
                        Text(stringResource(Res.string.chiudi_btn))
                    }
                },
                title = {
                    Text(
                        title,
                        style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Bold)
                    )
                },
                text = { Text(text, style = MaterialTheme.typography.bodyLarge) }
            )
        }

        val isPreview = LocalInspectionMode.current
        if (showOnboarding && !isPreview && !getPlatform().isWeb) {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.75f))
                    .pointerInput(Unit) {} // Block touch and click propagation to items behind the popup
                    .semantics { testTag = "onboarding_overlay" },
                contentAlignment = Alignment.Center
            ) {
                ElevatedCard(
                    modifier = Modifier
                        .fillMaxWidth(
                            if (deviceInfo.isLandscape) {
                                0.5f
                            } else {
                                0.9f
                            }
                        )
                        .padding(16.dp),
                    shape = RoundedCornerShape(24.dp)
                ) {
                    Column(
                        modifier = Modifier.padding(24.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Text(
                            text = stringResource(Res.string.walkthrough_welcome_title),
                            style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                            color = MaterialTheme.colorScheme.primary,
                            modifier = Modifier.padding(bottom = 16.dp)
                        )

                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(16.dp),
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Box(
                                modifier = Modifier
                                    .size(
                                        when (deviceInfo.deviceClass) {
                                            DeviceClass.PHONE_SMALL -> 64.dp
                                            DeviceClass.PHONE_MEDIUM -> 72.dp
                                            DeviceClass.PHONE_LARGE -> 80.dp
                                            DeviceClass.TABLET_MEDIUM -> 80.dp
                                            DeviceClass.TABLET_LARGE -> 100.dp
                                            DeviceClass.WEB_FULL -> 100.dp
                                        }
                                    )
                                    .background(
                                        color = MaterialTheme.colorScheme.onSecondaryContainer,
                                        shape = RoundedCornerShape(12.dp)
                                    )
                                    .padding(8.dp)
                            ) {
                                AlynAvatar(
                                    modifier = Modifier.fillMaxSize(),
                                    face = Faces.Happy,
                                    userData = userData
                                )
                            }

                            Text(
                                text = stringResource(Res.string.walkthrough_text),
                                style = MaterialTheme.typography.bodyMedium,
                                modifier = Modifier.weight(1f)
                            )
                        }

                        Spacer(modifier = Modifier.height(24.dp))

                        Button(
                            onClick = { onCompleteWalkthrough() },
                            shape = RoundedCornerShape(12.dp),
                            modifier = Modifier
                                .width(200.dp)
                                .semantics { testTag = "landing_btn_onboarding_start" }
                        ) {
                            Text(
                                text = stringResource(Res.string.inizia_btn)
                            )
                        }
                    }
                }
            }
        }

        val showTabWalkthrough = when (selectedIndex) {
            1 -> !userData.compendioWalkthroughDone
            2 -> !userData.builderWalkthroughDone
            3 -> !userData.charactersWalkthroughDone
            4 -> !userData.profileWalkthroughDone
            else -> false
        }

        if (showTabWalkthrough && !showOnboarding && !getPlatform().isWeb) {
            val tabWalkthroughTitle = when (selectedIndex) {
                1 -> stringResource(Res.string.walkthrough_welcome_compendio)
                2 -> stringResource(Res.string.walkthrough_welcome_builder)
                3 -> stringResource(Res.string.walkthrough_welcome_personaggi)
                4 -> stringResource(Res.string.walkthrough_welcome_profile)
                else -> ""
            }

            val tabWalkthroughText = when (selectedIndex) {
                1 -> stringResource(Res.string.walkthrough_text_compendio)
                2 -> stringResource(Res.string.walkthrough_text_builder)
                3 -> stringResource(Res.string.walkthrough_text_personaggi)
                4 -> stringResource(Res.string.walkthrough_text_profile)
                else -> ""
            }

            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.Black.copy(alpha = 0.75f))
                    .pointerInput(Unit) {} // Block touch and click propagation
                    .semantics { testTag = "tab_walkthrough_overlay" },
                contentAlignment = Alignment.Center
            ) {
                ElevatedCard(
                    modifier = Modifier
                        .fillMaxWidth(0.9f)
                        .padding(16.dp),
                    shape = RoundedCornerShape(24.dp)
                ) {
                    Column(
                        modifier = Modifier.padding(24.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Text(
                            text = tabWalkthroughTitle,
                            style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                            color = MaterialTheme.colorScheme.primary,
                            modifier = Modifier.padding(bottom = 16.dp)
                        )

                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(16.dp),
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Box(
                                modifier = Modifier
                                    .size(80.dp)
                                    .background(
                                        color = MaterialTheme.colorScheme.onSecondaryContainer,
                                        shape = RoundedCornerShape(12.dp)
                                    )
                                    .padding(8.dp)
                            ) {
                                AlynAvatar(
                                    modifier = Modifier.fillMaxSize(),
                                    face = Faces.Happy,
                                    userData = userData
                                )
                            }

                            Text(
                                text = tabWalkthroughText,
                                style = MaterialTheme.typography.bodyMedium,
                                modifier = Modifier.weight(1f)
                            )
                        }

                        Spacer(modifier = Modifier.height(24.dp))

                        Button(
                            onClick = { onCompleteTabWalkthrough(selectedIndex) },
                            shape = RoundedCornerShape(12.dp),
                            modifier = Modifier
                                .width(200.dp)
                                .semantics { testTag = "landing_btn_tab_walkthrough_close" }
                        ) {
                            Text(
                                text = stringResource(Res.string.chiudi_btn)
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun LessonStarsRow(
    stars: Int,
    earnedStars: Int,
    isPerfect: Boolean,
    starSize: Dp = 18.dp
) {
    val starsDescription = stringResource(Res.string.lesson_stars_earned_desc, earnedStars, stars)
    Row(
        modifier = Modifier.semantics(mergeDescendants = true) {
            contentDescription = starsDescription
        },
        verticalAlignment = Alignment.CenterVertically
    ) {
        repeat(stars) { starIndex ->
            Image(
                modifier = Modifier
                    .padding(end = 4.dp)
                    .size(starSize),
                painter = if (starIndex < earnedStars) {
                    if (isPerfect) {
                        painterResource(Res.drawable.stella_perfetta)
                    } else {
                        painterResource(Res.drawable.stella_full)
                    }
                } else {
                    painterResource(Res.drawable.stella)
                },
                contentDescription = null,
                colorFilter = ColorFilter.tint(MaterialTheme.colorScheme.onSurface)
            )
        }
    }
}

@Composable
private fun LeadingLessonSymbol(
    node: LessonNode,
    unlocked: Boolean,
    deviceInfo: DeviceInfo
) {
    val hieroRes = UniliteralRepository.resFromGardinerCode(node.hiero)
    val resource = hieroRes ?: when (node.type) {
        LessonType.SYMBOLS -> Res.drawable.occhio
        LessonType.VOCABULARY -> Res.drawable.bocca
        LessonType.GRAMMAR -> Res.drawable.libro
        LessonType.QUIZ -> Res.drawable.attrezzi_scriba
        LessonType.CHAT -> Res.drawable.A2
    }
    Image(
        modifier = Modifier.size(
            when (deviceInfo.deviceClass) {
                DeviceClass.PHONE_SMALL -> 36.dp
                DeviceClass.WEB_FULL -> 64.dp
                else -> 48.dp
            }
        ),
        painter = painterResource(resource),
        contentDescription = stringResource(node.title),
        colorFilter = ColorFilter.tint(
            if (hieroRes != null) {
                hieroglyphTint.copy(alpha = if (unlocked) 1f else 0.5f)
            } else {
                if (unlocked) {
                    MaterialTheme.colorScheme.onSurface
                } else {
                    lessonLockedTint
                }
            }
        )
    )
}

@Composable
private fun LessonActionButtons(
    node: LessonNode,
    unlocked: Boolean,
    canStartQuiz: Boolean,
    deviceInfo: DeviceInfo,
    onExplanationClick: (String) -> Unit,
    onQuizClick: (String) -> Unit
) {
    val hapticFeedback = LocalHapticFeedback.current
    val showChevron = LocalDensity.current.fontScale <= 1.49f
    if (unlocked) {
        ColumnOrRow(
            isLandscape = deviceInfo.isLandscape,
            isTablet = deviceInfo.isTablet
        ) {
            Button(
                onClick = {
                    hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                    onExplanationClick.invoke(node.id)
                },
                modifier = Modifier.width(
                    when (deviceInfo.deviceClass) {
                        DeviceClass.PHONE_SMALL -> 100.dp
                        DeviceClass.PHONE_MEDIUM -> 100.dp
                        else -> 120.dp
                    }
                ).height(
                    if (deviceInfo.deviceClass == DeviceClass.PHONE_SMALL) {
                        36.dp
                    } else {
                        48.dp
                    }
                ).semantics {
                    testTag = "explanation_button_${node.id}"
                },
                border = BorderStroke(
                    width = 1.dp,
                    color = MaterialTheme.colorScheme.primary.copy(alpha = 0.5f)
                ),
                contentPadding = PaddingValues(horizontal = 8.dp, vertical = 0.dp),
                colors = ButtonDefaults.buttonColors(
                    containerColor = MaterialTheme.colorScheme.primaryContainer,
                    contentColor = MaterialTheme.colorScheme.onPrimaryContainer,
                    disabledContainerColor = disabledNeutralBg,
                    disabledContentColor = disabledNeutralText
                ),
                shape = RoundedCornerShape(12.dp)
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center
                ) {
                    Text(
                        text = if (node.type != LessonType.CHAT) {
                            stringResource(Res.string.impara_btn)
                        } else {
                            stringResource(Res.string.investiga_btn)
                        },
                        style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold)
                    )
                    if (showChevron) {
                        Spacer(modifier = Modifier.width(4.dp))
                        Icon(
                            imageVector = FeatherIcons.ChevronRight,
                            contentDescription = null,
                            modifier = Modifier.size(16.dp)
                        )
                    }
                }
            }

            Button(
                onClick = {
                    hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                    onQuizClick.invoke(node.id)
                },
                enabled = canStartQuiz,
                modifier = Modifier.width(
                    when (deviceInfo.deviceClass) {
                        DeviceClass.PHONE_SMALL -> 100.dp
                        DeviceClass.PHONE_MEDIUM -> 100.dp
                        else -> 120.dp
                    }
                ).height(
                    if (deviceInfo.deviceClass == DeviceClass.PHONE_SMALL) {
                        36.dp
                    } else {
                        48.dp
                    }
                ).semantics { testTag = "quiz_button_${node.id}" },
                border = BorderStroke(
                    width = 1.dp,
                    color = if (canStartQuiz) {
                        MaterialTheme.colorScheme.primary.copy(alpha = 0.5f)
                    } else {
                        lessonLockedButtonBorder
                    }
                ),
                contentPadding = PaddingValues(horizontal = 8.dp, vertical = 0.dp),
                colors = ButtonDefaults.buttonColors(
                    containerColor = MaterialTheme.colorScheme.primaryContainer,
                    contentColor = MaterialTheme.colorScheme.onPrimaryContainer,
                    disabledContainerColor = disabledNeutralBg,
                    disabledContentColor = disabledNeutralText
                ),
                shape = RoundedCornerShape(12.dp)
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center
                ) {
                    Text(
                        text = stringResource(Res.string.quiz_btn),
                        style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold)
                    )
                    if (showChevron) {
                        Spacer(modifier = Modifier.width(4.dp))
                        Icon(
                            imageVector = FeatherIcons.ChevronRight,
                            contentDescription = null,
                            modifier = Modifier.size(16.dp)
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun ChaptersScreen(
    uiState: LandingUiState,
    onExplanationClick: (String) -> Unit,
    onQuizClick: (String) -> Unit,
    modifier: Modifier,
    starsNeeded: Map<String, Int>
) {
    if (uiState.chapters.isEmpty()) {
        Box(modifier = modifier)
    } else {
        ChaptersListContent(
            uiState = uiState,
            onExplanationClick = onExplanationClick,
            onQuizClick = onQuizClick,
            starsNeeded = starsNeeded,
            modifier = modifier
        )
    }
}

@Composable
fun ChaptersListContent(
    uiState: LandingUiState,
    onExplanationClick: (String) -> Unit,
    onQuizClick: (String) -> Unit,
    starsNeeded: Map<String, Int>,
    modifier: Modifier
) {
    val deviceInfo = rememberDeviceInfo()

    val hapticFeedback = LocalHapticFeedback.current
    val scope = rememberCoroutineScope()

    val firstLockedLessonId = remember(uiState) {
        var foundId: String? = null
        outer@ for (chapter in uiState.chapters) {
            val rows = uiState.lessonRowsPerChapter[chapter.number] ?: emptyList()
            for (row in rows) {
                for (uiNode in row.lessons) {
                    if (uiNode.isLocked) {
                        foundId = uiNode.lesson.id
                        break@outer
                    }
                }
            }
        }
        foundId
    }

    val currentLessonId = remember(uiState) {
        var foundId: String? = null
        outerLoop@ for (chapter in uiState.chapters) {
            val rows = uiState.lessonRowsPerChapter[chapter.number] ?: emptyList()
            for (row in rows) {
                for (uiNode in row.lessons) {
                    if (!uiNode.isLocked && uiNode.earnedStars == 0) {
                        foundId = uiNode.lesson.id
                        break@outerLoop
                    }
                }
            }
        }
        foundId
    }

    val firstLessonToWorkOnIndex = remember(uiState) {
        var targetChapterNumber: Int? = null
        var targetRowIndex: Int? = null

        outerLoop@ for (chapter in uiState.chapters) {
            val rows = uiState.lessonRowsPerChapter[chapter.number] ?: emptyList()
            for (rIndex in rows.indices) {
                val row = rows[rIndex]
                val hasActiveLesson = row.lessons.any { !it.isLocked && it.earnedStars == 0 }
                if (hasActiveLesson) {
                    targetChapterNumber = chapter.number
                    targetRowIndex = rIndex
                    break@outerLoop
                }
            }
        }

        if (targetChapterNumber != null && targetRowIndex != null) {
            var flatIndex = 0
            for (chapter in uiState.chapters) {
                if (chapter.number == targetChapterNumber) {
                    flatIndex += 1 // stickyHeader
                    flatIndex += targetRowIndex
                    break
                } else {
                    val rowsCount = uiState.lessonRowsPerChapter[chapter.number]?.size ?: 0
                    flatIndex += 1 // stickyHeader
                    flatIndex += rowsCount
                }
            }
            flatIndex
        } else {
            null
        }
    }

    val density = LocalDensity.current
    val scrollOffsetPx = remember(density) {
        with(density) { -80.dp.roundToPx() }
    }

    val isFirstLessonTarget = remember(uiState) {
        var targetChapterNumber: Int? = null
        var targetRowIndex: Int? = null

        outerLoop@ for (chapter in uiState.chapters) {
            val rows = uiState.lessonRowsPerChapter[chapter.number] ?: emptyList()
            for (rIndex in rows.indices) {
                val row = rows[rIndex]
                val hasActiveLesson = row.lessons.any { !it.isLocked && it.earnedStars == 0 }
                if (hasActiveLesson) {
                    targetChapterNumber = chapter.number
                    targetRowIndex = rIndex
                    break@outerLoop
                }
            }
        }

        val firstChapterNumber = uiState.chapters.firstOrNull()?.number
        firstChapterNumber != null && targetChapterNumber == firstChapterNumber && targetRowIndex == 0
    }

    val lastItemIndex = remember(uiState) {
        var totalItemsCount = 0
        for (chapter in uiState.chapters) {
            totalItemsCount += 1 // stickyHeader
            val rowsCount = uiState.lessonRowsPerChapter[chapter.number]?.size ?: 0
            totalItemsCount += rowsCount
        }
        totalItemsCount
    }

    val allLessonsCompleted = remember(uiState) {
        val allNodes = uiState.lessonRowsPerChapter.values.flatten().flatMap { it.lessons }
        allNodes.isNotEmpty() && allNodes.all { it.earnedStars > 0 }
    }

    val initialIndex =
        remember(firstLessonToWorkOnIndex, isFirstLessonTarget, lastItemIndex, allLessonsCompleted) {
            if (firstLessonToWorkOnIndex != null && !isFirstLessonTarget) {
                firstLessonToWorkOnIndex
            } else if (allLessonsCompleted) {
                lastItemIndex
            } else {
                0
            }
        }
    val initialOffset = remember(firstLessonToWorkOnIndex, isFirstLessonTarget, scrollOffsetPx) {
        if (firstLessonToWorkOnIndex != null && !isFirstLessonTarget) scrollOffsetPx else 0
    }

    val listState = rememberLazyListState(
        initialFirstVisibleItemIndex = initialIndex,
        initialFirstVisibleItemScrollOffset = initialOffset
    )

    val showScrollToCurrentFab by remember(listState, firstLessonToWorkOnIndex) {
        derivedStateOf {
            val targetIndex = firstLessonToWorkOnIndex ?: return@derivedStateOf false
            val visibleIndexes = listState.layoutInfo.visibleItemsInfo.map { it.index }
            targetIndex !in visibleIndexes
        }
    }
    val fontScale = LocalDensity.current.fontScale
    val isHighScale = fontScale > 1.49f
    Box(modifier = modifier) {
        // ChaptersScreen — LazyColumn
        LazyColumn(
            state = listState,
            modifier = Modifier
                .fillMaxSize()
                .semantics { testTag = "chapters_list" },
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            uiState.chapters.forEach { chapter ->
                val rows = uiState.lessonRowsPerChapter[chapter.number] ?: emptyList()
                val isAnyLessonUnlocked = rows.flatMap { it.lessons }.any { !it.isLocked }

                stickyHeader {
                    val allLessonsInChapter = rows.flatMap { it.lessons }
                    val totalLessons = allLessonsInChapter.size
                    val earnedStars = allLessonsInChapter.sumOf { it.earnedStars }
                    val maxStars = totalLessons * 3
                    val perfectLessons = allLessonsInChapter.count { it.isPerfect }

                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(MaterialTheme.colorScheme.surface)
                            .padding(vertical = 8.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        val title = stringResource(
                            Res.string.chapter_title_format,
                            chapter.number,
                            stringResource(chapter.title)
                        ).toUpperCase(Locale.current)

                        val label = if (isHighScale) {
                            title.split(":")[1]
                        } else {
                            title
                        }
                        Text(
                            text = label,
                            style = MaterialTheme.typography.bodyLarge.copy(fontWeight = FontWeight.Bold),
                            color = MaterialTheme.colorScheme.onSecondaryContainer,
                            modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
                            textAlign = TextAlign.Center,
                        )

                        if (totalLessons > 0 && isAnyLessonUnlocked) {
                            Spacer(modifier = Modifier.height(4.dp))

                            val earnedRatio =
                                if (maxStars > 0) (earnedStars.toFloat() / maxStars).coerceIn(
                                    0f,
                                    1f
                                ) else 0f
                            val perfectRatio =
                                if (totalLessons > 0) (perfectLessons.toFloat() / totalLessons).coerceIn(
                                    0f,
                                    1f
                                ) else 0f

                            Box(
                                modifier = Modifier
                                    .width(180.dp)
                                    .height(5.dp)
                                    .background(
                                        color = MaterialTheme.colorScheme.surfaceVariant,
                                        shape = RoundedCornerShape(3.dp)
                                    )
                            ) {
                                if (earnedRatio > 0f) {
                                    Box(
                                        modifier = Modifier
                                            .fillMaxHeight()
                                            .fillMaxWidth(earnedRatio)
                                            .background(
                                                color = MaterialTheme.colorScheme.primary,
                                                shape = RoundedCornerShape(3.dp)
                                            )
                                    )
                                }
                                if (perfectRatio > 0f) {
                                    Box(
                                        modifier = Modifier
                                            .fillMaxHeight()
                                            .fillMaxWidth(perfectRatio)
                                            .background(
                                                color = Color(0xFFFFB800),
                                                shape = RoundedCornerShape(3.dp)
                                            )
                                    )
                                }
                            }
                        }
                    }
                }

                itemsIndexed(
                    items = rows,
                    key = { _, row -> "chapter_${chapter.number}_row_${row.lessons.firstOrNull()?.id ?: ""}" }
                ) { _, uiRow ->

                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(
                                horizontal = if (deviceInfo.deviceClass == DeviceClass.WEB_FULL) {
                                    32.dp
                                } else {
                                    16.dp
                                }
                            ),
                        verticalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        uiRow.lessons.forEach { uiNode ->
                            val node = uiNode.lesson
                            val unlocked = !uiNode.isLocked

                            if (node.id == currentLessonId) {
                                Row(
                                    verticalAlignment = Alignment.CenterVertically,
                                    modifier = Modifier.fillMaxWidth().padding(bottom = 8.dp)
                                ) {
                                    val face = when (chapter.number % 2) {
                                        0 -> Faces.Perfect
                                        1 -> Faces.Happy
                                        else -> Faces.Surprised
                                    }
                                    val deviceInfo = rememberDeviceInfo()
                                    val avatarWidth = when (deviceInfo.deviceClass) {
                                        DeviceClass.PHONE_SMALL -> 64.dp
                                        DeviceClass.PHONE_MEDIUM -> 72.dp
                                        else -> 80.dp
                                    }
                                    InteractiveAvatar(
                                        character = chapter.character,
                                        userData = uiState.userData,
                                        baseFace = face,
                                        modifier = Modifier.height(avatarWidth)
                                    )
                                    Spacer(modifier = Modifier.width(8.dp))
                                    Image(
                                        modifier = Modifier.width(12.dp),
                                        painter = painterResource(Res.drawable.triangle90),
                                        contentDescription = null,
                                        colorFilter = ColorFilter.tint(MaterialTheme.colorScheme.outlineVariant)
                                    )
                                    OutlinedCard(
                                        modifier = Modifier.weight(1f)
                                    ) {
                                        Text(
                                            modifier = Modifier.fillMaxWidth().padding(8.dp),
                                            text = stringResource(node.description),
                                            style = MaterialTheme.typography.bodyLarge,
                                            textAlign = TextAlign.Center
                                        )
                                    }
                                }
                            }

                            val canStartQuiz =
                                uiState.userData.explanations.contains(node.id)

                            Box(
                                modifier = Modifier.fillMaxWidth()
                            ) {
                                Card(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .padding(vertical = 4.dp)
                                        .semantics { testTag = "lesson_card_${node.id}" },
                                    shape = RoundedCornerShape(16.dp),
                                    colors = CardDefaults.cardColors(
                                        containerColor = if (unlocked) {
                                            if (uiNode.isPerfect) {
                                                lessonPerfectContainer
                                            } else {
                                                MaterialTheme.colorScheme.surfaceVariant.copy(
                                                    alpha = if (unlocked && uiNode.earnedStars > 0) 0.5f else 1f
                                                )
                                            }
                                        } else {
                                            lessonLockedContainer
                                        }
                                    ),
                                    border = BorderStroke(
                                        width = 2.dp,
                                        color = if (unlocked) {
                                            MaterialTheme.colorScheme.outlineVariant
                                        } else {
                                            disabledNeutralBg
                                        }
                                    )
                                ) {
                                    val isWebFullLesson =
                                        deviceInfo.deviceClass == DeviceClass.WEB_FULL

                                    if (isWebFullLesson) {
                                        Row(
                                            modifier = Modifier
                                                .fillMaxWidth()
                                                .padding(horizontal = 16.dp, vertical = 12.dp),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            Row(
                                                modifier = Modifier.weight(1f),
                                                verticalAlignment = Alignment.CenterVertically
                                            ) {
                                                LeadingLessonSymbol(
                                                    node = node,
                                                    unlocked = unlocked,
                                                    deviceInfo = deviceInfo
                                                )
                                                Spacer(modifier = Modifier.width(12.dp))
                                                Text(
                                                    text = stringResource(node.title),
                                                    style = MaterialTheme.typography.titleMedium.copy(
                                                        fontWeight = FontWeight.Bold
                                                    ),
                                                    color = if (unlocked) {
                                                        MaterialTheme.colorScheme.onSurface
                                                    } else {
                                                        lessonLockedTint
                                                    },
                                                    maxLines = 2,
                                                    overflow = TextOverflow.Ellipsis
                                                )
                                            }
                                            Box(
                                                modifier = Modifier.weight(1f),
                                                contentAlignment = Alignment.Center
                                            ) {
                                                if (unlocked) {
                                                    LessonStarsRow(
                                                        stars = node.stars,
                                                        earnedStars = uiNode.earnedStars,
                                                        isPerfect = uiNode.isPerfect,
                                                        starSize = 30.dp
                                                    )
                                                }
                                            }
                                            Box(
                                                modifier = Modifier.weight(1f),
                                                contentAlignment = Alignment.CenterEnd
                                            ) {
                                                LessonActionButtons(
                                                    node = node,
                                                    unlocked = unlocked,
                                                    canStartQuiz = canStartQuiz,
                                                    deviceInfo = deviceInfo,
                                                    onExplanationClick = onExplanationClick,
                                                    onQuizClick = onQuizClick
                                                )
                                            }
                                        }
                                    } else {
                                        ListItem(
                                            colors = ListItemDefaults.colors(
                                                containerColor = Color.Transparent
                                            ),
                                            leadingContent = {
                                                LeadingLessonSymbol(
                                                    node = node,
                                                    unlocked = unlocked,
                                                    deviceInfo = deviceInfo
                                                )
                                            },
                                            headlineContent = {
                                                Text(
                                                    text = stringResource(node.title),
                                                    style = if (deviceInfo.deviceClass == DeviceClass.PHONE_SMALL) {
                                                        MaterialTheme.typography.titleSmall.copy(
                                                            fontWeight = FontWeight.Bold
                                                        )
                                                    } else {
                                                        MaterialTheme.typography.titleMedium.copy(
                                                            fontWeight = FontWeight.Bold
                                                        )
                                                    },
                                                    color = if (unlocked) {
                                                        MaterialTheme.colorScheme.onSurface
                                                    } else {
                                                        lessonLockedTint
                                                    },
                                                    maxLines = 2,
                                                    overflow = TextOverflow.Ellipsis
                                                )
                                            },
                                            supportingContent = if (unlocked) {
                                                {
                                                    // Stelle sotto
                                                    Row(
                                                        verticalAlignment = Alignment.CenterVertically,
                                                        modifier = Modifier.padding(top = 4.dp)
                                                    ) {
                                                        LessonStarsRow(
                                                            stars = node.stars,
                                                            earnedStars = uiNode.earnedStars,
                                                            isPerfect = uiNode.isPerfect
                                                        )
                                                    }
                                                }
                                            } else {
                                                null
                                            },
                                            trailingContent = {
                                                LessonActionButtons(
                                                    node = node,
                                                    unlocked = unlocked,
                                                    canStartQuiz = canStartQuiz,
                                                    deviceInfo = deviceInfo,
                                                    onExplanationClick = onExplanationClick,
                                                    onQuizClick = onQuizClick
                                                )
                                            }
                                        )
                                    }

                                    if (unlocked && !canStartQuiz) {
                                        Box(
                                            modifier = Modifier
                                                .fillMaxWidth()
                                                .padding(start = 16.dp, end = 16.dp, bottom = 16.dp)
                                                .background(
                                                    color = MaterialTheme.colorScheme.tertiaryContainer,
                                                    shape = RoundedCornerShape(8.dp)
                                                )
                                                .border(
                                                    width = 1.dp,
                                                    color = MaterialTheme.colorScheme.onTertiaryContainer,
                                                    shape = RoundedCornerShape(8.dp)
                                                )
                                                .padding(8.dp)
                                        ) {
                                            Text(
                                                modifier = Modifier.fillMaxWidth(),
                                                text = stringResource(Res.string.unlock_quiz_explanation_hint),
                                                style = MaterialTheme.typography.bodySmall.copy(
                                                    fontWeight = FontWeight.Medium
                                                ),
                                                color = lessonHintText,
                                                textAlign = TextAlign.Center
                                            )
                                        }
                                    }

                                    // IF LOCKED: Show locked requirements
                                    if (!unlocked && node.id == firstLockedLessonId) {
                                        Box(
                                            modifier = Modifier
                                                .fillMaxWidth()
                                                .padding(start = 16.dp, end = 16.dp, bottom = 16.dp)
                                                .background(
                                                    color = MaterialTheme.colorScheme.tertiaryContainer,
                                                    shape = RoundedCornerShape(8.dp)
                                                )
                                                .border(
                                                    width = 1.dp,
                                                    color = MaterialTheme.colorScheme.onTertiaryContainer,
                                                    shape = RoundedCornerShape(8.dp)
                                                )
                                                .padding(8.dp)
                                        ) {
                                            Text(
                                                text = stringResource(
                                                    Res.string.unlock_requirements_hint,
                                                    starsNeeded[node.id] ?: 0
                                                ),
                                                style = MaterialTheme.typography.bodySmall.copy(
                                                    fontWeight = FontWeight.Medium
                                                ),
                                                color = lessonHintText,
                                                textAlign = TextAlign.Center
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Banner "tutte le lezioni completate" in fondo
            if (allLessonsCompleted) {
                item(key = "all_lessons_completed_banner") {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(horizontal = 16.dp, vertical = 16.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            InteractiveAvatar(
                                character = Characters.Alyn,
                                userData = uiState.userData,
                                baseFace = Faces.Perfect,
                                modifier = Modifier.height(96.dp)
                            )
                            Spacer(modifier = Modifier.width(8.dp))
                            Image(
                                modifier = Modifier.width(12.dp),
                                painter = painterResource(Res.drawable.triangle90),
                                contentDescription = null,
                                colorFilter = ColorFilter.tint(MaterialTheme.colorScheme.outlineVariant)
                            )
                            OutlinedCard(
                                modifier = Modifier.weight(1f)
                            ) {
                                Text(
                                    modifier = Modifier.fillMaxWidth().padding(8.dp),
                                    text = stringResource(Res.string.all_lessons_completed),
                                    style = MaterialTheme.typography.bodyLarge,
                                    textAlign = TextAlign.Center
                                )
                            }
                        }

                        Spacer(modifier = Modifier.height(16.dp))

                        Button(
                            onClick = {
                                hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                                onQuizClick.invoke(LessonIds.DAILY_REVIEW)
                            },
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(horizontal = 16.dp)
                                .semantics { testTag = "daily_review_button" },
                            border = BorderStroke(
                                width = 1.dp,
                                color = MaterialTheme.colorScheme.primary.copy(alpha = 0.5f)
                            ),
                            colors = ButtonDefaults.buttonColors(
                                containerColor = MaterialTheme.colorScheme.primaryContainer,
                                contentColor = MaterialTheme.colorScheme.onPrimaryContainer
                            ),
                            shape = RoundedCornerShape(12.dp)
                        ) {
                            Row(
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.Center,
                                modifier = Modifier.padding(vertical = 4.dp)
                            ) {
                                Text(
                                    text = stringResource(Res.string.daily_review_btn),
                                    style = MaterialTheme.typography.bodyMedium.copy(
                                        fontWeight = FontWeight.Bold
                                    )
                                )
                                Spacer(modifier = Modifier.width(4.dp))
                                Icon(
                                    imageVector = FeatherIcons.ChevronRight,
                                    contentDescription = null,
                                    modifier = Modifier.size(16.dp)
                                )
                            }
                        }

                        val sendFeedback = rememberFeedbackSender()
                        val emailSubject =
                            stringResource(Res.string.request_more_lessons_email_subject)
                        val emailTemplate =
                            stringResource(Res.string.request_more_lessons_email_body)
                        val userStats = """
                            Total stars: ${uiState.userData.stars.values.sum()}
                            Perfect lessons: ${uiState.userData.perfect.size}
                            Streak: ${uiState.userData.strike} days
                            Experience: ${uiState.userData.experience}
                        """.trimIndent()
                        val feedbackDebugInfo =
                            rememberFeedbackDebugInfo(FeedbackType.MORE_LESSONS, extra = userStats)

                        Spacer(modifier = Modifier.height(12.dp))

                        OutlinedButton(
                            onClick = {
                                hapticFeedback.performHapticFeedback(HapticFeedbackType.LongPress)
                                try {
                                    sendFeedback(
                                        FeedbackEmail(
                                            subject = emailSubject,
                                            templateBody = emailTemplate,
                                            debugInfo = feedbackDebugInfo
                                        )
                                    )
                                } catch (e: Exception) {
                                    println("Failed to open mail client: ${e.message}")
                                }
                            },
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(horizontal = 16.dp)
                                .semantics { testTag = "request_more_lessons_button" },
                            border = BorderStroke(
                                width = 1.dp,
                                color = MaterialTheme.colorScheme.primary.copy(alpha = 0.5f)
                            ),
                            colors = ButtonDefaults.outlinedButtonColors(
                                contentColor = MaterialTheme.colorScheme.primary
                            ),
                            shape = RoundedCornerShape(12.dp)
                        ) {
                            Row(
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.Center,
                                modifier = Modifier.padding(vertical = 4.dp)
                            ) {
                                Icon(
                                    imageVector = FeatherIcons.Mail,
                                    contentDescription = null,
                                    modifier = Modifier.size(16.dp)
                                )
                                Spacer(modifier = Modifier.width(8.dp))
                                Text(
                                    text = stringResource(Res.string.request_more_lessons_btn),
                                    style = MaterialTheme.typography.bodyMedium.copy(
                                        fontWeight = FontWeight.Bold
                                    ),
                                    textAlign = TextAlign.Center
                                )
                            }
                        }
                    }
                }
            }
        }

        AnimatedVisibility(
            visible = showScrollToCurrentFab,
            enter = fadeIn() + scaleIn(),
            exit = fadeOut() + scaleOut(),
            modifier = Modifier
                .align(Alignment.BottomEnd)
                .padding(20.dp)
        ) {
            FloatingActionButton(
                onClick = {
                    val targetIndex = firstLessonToWorkOnIndex ?: return@FloatingActionButton
                    scope.launch {
                        listState.animateScrollToItem(
                            index = targetIndex,
                            scrollOffset = scrollOffsetPx
                        )
                    }
                },
                modifier = Modifier.semantics { testTag = "chapters_btn_scroll_to_current" }
            ) {
                Image(
                    painter = painterResource(Res.drawable.A33),
                    contentDescription = stringResource(Res.string.scroll_to_current_lesson_desc),
                    modifier = Modifier.size(24.dp),
                    colorFilter = ColorFilter.tint(MaterialTheme.colorScheme.onPrimaryContainer)
                )
            }
        }
    }
}
